import MyNewsAdminSettingsPage from "my-news/pages/admin-settings-page";
import MyNewsEditPage from "my-news/pages/edit-page";
import MyNewsListPage from "my-news/pages/list-page";
import MyNewsNewPage from "my-news/pages/new-page";
import MyNewsShowPage from "my-news/pages/show-page";

export const myNewsListPageRoute = "/my-news";
export const myNewsEditPageRoute = "/my-news/edit/:id";
export const myNewsNewPageRoute = "/my-news/new";
export const myNewsShowPageRoute = "/my-news/show/:id";
export const myNewsAdminSettingsPageRoute = "/my-news/admin/settings";

export const buildMyNewsEditPageRoute = (id: string) => `/my-news/edit/${id}`;
export const buildMyNewsShowPageRoute = (id: string) => `/my-news/show/${id}`;

export const myNewsRoutes = [
  {
    id: "myNewsListPageRoute",
    path: myNewsListPageRoute,
    exact: true,
    private: true,
    component: MyNewsListPage,
    roles: ["MyNews.user", "MyNews.editor"],
  },
  {
    id: "myNewsEditPageRoute",
    path: myNewsEditPageRoute,
    exact: true,
    private: true,
    component: MyNewsEditPage,
    roles: ["MyNews.editor"],
  },
  {
    id: "myNewsNewPageRoute",
    path: myNewsNewPageRoute,
    exact: true,
    private: true,
    component: MyNewsNewPage,
    roles: ["MyNews.editor"],
  },
  {
    id: "myNewsShowPageRoute",
    path: myNewsShowPageRoute,
    exact: true,
    private: true,
    component: MyNewsShowPage,
    roles: ["MyNews.user", "MyNews.editor"],
  },
  {
    id: "myNewsAdminSettingsPageRoute",
    path: myNewsAdminSettingsPageRoute,
    exact: true,
    private: true,
    component: MyNewsAdminSettingsPage,
    roles: ["MyNews.admin"],
  },
];
